module.exports = __webpack_public_path__ + "static/img/business79.329d149.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/business/business79.png
// module id = iQN3
// module chunks = 9